import React, { useRef, useState } from "react";
import Slider from "react-slick";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Home.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import ImageLoader from "../ImageLoader/ImageLoader";
import AnimateOnScroll from "../AnimateOnScroll/AnimateOnScroll";
import { useTranslation } from "react-i18next";

const Home = () => {
  const { t } = useTranslation();
  const sliderRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    centerMode: true,
    centerPadding: "0px",
    arrows: false, // We are using custom arrows
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const sliderContent = [
    <div className="image-card" key={0}>
      <img src="/images/O1.jpg" alt="" />
    </div>,
    <div className="image-card" key={1}>
      <img src="/images/new_31.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/pool.jpg" alt="" />
    </div>,
    <div className="image-card" key={3}>
      <img src="/images/new_27_1.jpg" alt="" />
    </div>,
    <div className="image-card" key={4}>
      <img src="/images/DDK_0007p5.jpg" alt="" />
    </div>,
    <div className="image-card" key={5}>
      <img src="/images/sky_03.jpg" alt="" />
    </div>,
    <div className="image-card" key={6}>
      <img src="/images/new_37.jpg" alt="" />
    </div>,
  ];

  const slides = sliderContent.map((card) => ({
    src: card.props.children.props.src,
  }));

  const openLightbox = (idx) => {
    setIndex(idx);
    setOpen(true);
  };

  return (
    <ImageLoader>
      <Container>
        <Row>
          <Col>
            <div className="accommodation section">
              <video autoPlay muted loop style={{ width: "100%" }}>
                <source
                  src="/images/videos/Oasis Homepage.mp4"
                  type="video/mp4"
                />
              </video>
              <AnimateOnScroll animationType="slideUp">
                <h2 dangerouslySetInnerHTML={{ __html: t("home_main_title") }} />
                <p>{t("home_main_p")}</p>
              </AnimateOnScroll>
              <AnimateOnScroll animationType="slideup">
                <div className="image-slider">
                  <div className="slider-container">
                    <button
                      className="slick-prev-custom"
                      onClick={() => sliderRef.current.slickPrev()}
                    >
                      <FaArrowLeft />
                    </button>
                    <div className="slider-wrapper">
                      <Slider ref={sliderRef} {...sliderSettings}>
                        {sliderContent.map((card, idx) =>
                          React.cloneElement(card, {
                            onClick: () => openLightbox(slides, idx),
                          }),
                        )}
                      </Slider>
                    </div>
                    <button
                      className="slick-next-custom"
                      onClick={() => sliderRef.current.slickNext()}
                    >
                      <FaArrowRight />
                    </button>
                  </div>
                </div>
              </AnimateOnScroll>
              <Lightbox
                open={open}
                close={() => setOpen(false)}
                slides={slides}
                index={index}
              />
              <AnimateOnScroll animationType="slideUp">
                <h2
                  dangerouslySetInnerHTML={{ __html: t("home_indulge_title") }}
                />
              </AnimateOnScroll>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="section">
              <AnimateOnScroll animationType="slideup">
                <div className="lifestyle section">
                  <Row>
                    <Col md={4}>
                      <div className="masonry-item">
                        <img src="/images/new_05.jpg" alt="" />
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="masonry-item">
                        <img src="/images/02_02.jpg" alt="" />
                      </div>
                      <div className="masonry-item">
                        <img src="/images/02_04.jpg" alt="" />
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="masonry-item">
                        <img src="/images/new_04.jpg" alt="" />
                      </div>
                      <div className="masonry-item">
                        <img src="/images/new_19.jpg" alt="" />
                      </div>
                      <div className="masonry-item">
                        <img src="/images/new_20.jpg" alt="" />
                      </div>
                    </Col>
                  </Row>
                </div>
              </AnimateOnScroll>
              <AnimateOnScroll animationType="slideUp">
                <h2
                  dangerouslySetInnerHTML={{
                    __html: t("home_all_in_one_title"),
                  }}
                />
                <p>{t("home_all_in_one_p")}</p>
                <Link
                  to="/residence/apartments-plans"
                  className="discover-link"
                >
                  {t("home_view_apartments_btn")}
                </Link>
              </AnimateOnScroll>
              <AnimateOnScroll animationType="slideup">
                <div className="lifestyle section">
                  <Row>
                    <Col md={1}></Col>
                    <Col md={6}>
                      <div className="masonry-item">
                        <img src="/images/sky_01.jpg" alt="" />
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="masonry-item">
                        <img src="/images/pic_08.jpg" alt="" />
                      </div>
                      <div className="masonry-item">
                        <img src="/images/plan1.jpg" alt="" />
                      </div>
                      <div className="masonry-item">
                        <img src="/images/sky_02.jpg" alt="" />
                      </div>
                    </Col>
                    <Col md={1}></Col>
                  </Row>
                </div>
              </AnimateOnScroll>
            </div>
          </Col>
        </Row>
      </Container>
    </ImageLoader>
  );
};

export default Home;
